import type { CSSProperties, ReactNode } from "react";
import type { FormAppearanceDto } from "../../types/appearance";
import {
  FALLBACK_FORM_THEMES,
  formAppearanceCssVars,
  resolveAppearanceForRender,
} from "../../lib/forms/appearance";

interface FormShellProps {
  appearance?: FormAppearanceDto | null;
  className?: string;
  children: ReactNode;
}

export function FormShell({
  appearance,
  className = "",
  children,
}: FormShellProps) {
  const styles = resolveAppearanceForRender(
    appearance,
    FALLBACK_FORM_THEMES.themes,
  );

  const shellStyle: CSSProperties = {
    ...formAppearanceCssVars(styles),
    maxWidth: styles.maxWidth,
    color: "var(--form-text)",
    fontFamily: styles.fontFamily === "inherit" ? undefined : styles.fontFamily,
  };

  return (
    <div
      className={`form-themed form-page ${className}`.trim()}
      style={shellStyle}
    >
      {children}
    </div>
  );
}
